// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
import { displaySuccessMessage, displayErrorMessage } from '@insticator/insticator-ui'
import store from '../store/store'
// api
import * as endUserAuthAPI from './api/eua'

// thunks
export const fetchProfileConfig = createAsyncThunk(
    'profile/fetchProfileConfig',
    async (siteId) => {
        const response = await endUserAuthAPI.getProfileConfig(siteId)
        return response.data
    }
);

export const updateProfileConfig = createAsyncThunk('profile/updateProfileConfig',
    async (payload, { rejectWithValue }) => {
        const { config } = payload
        try {
            const response = await endUserAuthAPI.updateProfileConfig({  configUUID: config.uuid, requestData: config })
            store.dispatch(displaySuccessMessage('Profile config updated.'))
            return {...config}
            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            const error = errResponse?.payload || 'There was an issue updating this profile config'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);
